import { normalizeSheetRows } from "./payloadRows";
import { resolveRoomDefinitionListOrder } from "./roomDefinitionRows";
import { isSampleTestRow } from "./sampleDataFilter";

const readListOrderSource = (row: Record<string, unknown>): unknown =>
  row["List Order"] ?? row.ListOrder ?? row.listOrder;

/** Assigns ListOrder sequentially when not configured on the Guest Type row. */
export const mapGuestTypeExportRows = (
  sheetData: unknown,
): Record<string, unknown>[] =>
  normalizeSheetRows(sheetData)
    .filter((row) => !isSampleTestRow(row))
    .map((row, index) => ({
      ...row,
      "List Order": resolveRoomDefinitionListOrder(
        readListOrderSource(row),
        index,
      ),
    }));
